
import { SearchOutlined } from '@ant-design/icons-vue';
import { reactive, toRefs } from 'vue';
export default {
  name: 'EaSearch',
  components: {
    SearchOutlined,
  },
  emits: ['searchNameClick'],
  props: {
    searchsData: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const pagedatas = reactive({
      searchName: '',
      showcontents: false,
    });
    const inputs = () => {
      ctx.emit('searchNameClick', pagedatas.searchName);
    };
    const foucs = (vals) => {
      pagedatas.showcontents = vals;
      vals ? '' : (pagedatas.searchName = '');
      ctx.emit('searchNameClick', pagedatas.searchName);
    };
    const Searchs = (vals) => {
      pagedatas.searchName = vals.name;
    };

    return {
      inputs,
      foucs,
      Searchs,
      ...toRefs(pagedatas),
    };
  },
};
